import React from 'react';
import { Hammer, RefreshCw, HardHat, ShieldAlert } from 'lucide-react';

const Maintenance = () => {
    return (
        <div className="min-h-screen bg-[#09090b] text-[#fafafa] flex items-center justify-center p-4 relative overflow-hidden font-sans">
            {/* Background Glows */}
            <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-1/4 left-1/3 w-72 h-72 bg-blue-500/5 rounded-full blur-3xl"></div>

            <div className="max-w-md w-full text-center space-y-8 relative z-10">
                {/* Visual Icon with pulsating animation */}
                <div className="flex justify-center">
                    <div className="relative">
                        <div className="absolute inset-0 bg-purple-500/20 rounded-full blur-xl animate-pulse"></div>
                        <div className="w-24 h-24 bg-zinc-900 border border-purple-500/30 rounded-full flex items-center justify-center text-purple-400 relative z-10 animate-bounce duration-1000">
                            <Hammer size={40} />
                        </div>
                    </div>
                </div>

                <div className="space-y-3">
                    <span className="px-3 py-1 bg-purple-500/10 border border-purple-500/20 text-purple-400 text-[10px] font-black uppercase tracking-widest rounded-full inline-flex items-center gap-1.5">
                        <ShieldAlert size={10} /> Mantenimiento Programado
                    </span>
                    <h1 className="text-3xl font-extrabold tracking-tight text-white">
                        Plataforma en <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-indigo-500">Mantenimiento</span>
                    </h1>
                    <p className="text-zinc-400 text-xs leading-relaxed max-w-sm mx-auto font-medium">
                        Estamos realizando mejoras y optimizaciones en la infraestructura para brindarte un servicio más estable y veloz.
                    </p>
                </div>

                <div className="bg-zinc-900/60 backdrop-blur-xl border border-zinc-800 rounded-3xl p-5 shadow-xl space-y-4">
                    <div className="flex items-center gap-3 text-left">
                        <div className="p-2 bg-purple-500/10 rounded-xl text-purple-400 shrink-0">
                            <HardHat size={16} />
                        </div>
                        <div>
                            <h4 className="text-xs font-bold text-white">¿Qué significa esto?</h4>
                            <p className="text-[10px] text-zinc-550 leading-relaxed mt-0.5">
                                El acceso a la API y sincronización de obra se encuentra pausado temporalmente. Ningún dato se perderá durante este proceso.
                            </p>
                        </div>
                    </div>

                    <div className="flex items-center gap-3 text-left border-t border-zinc-800/60 pt-4">
                        <div className="p-2 bg-blue-500/10 rounded-xl text-blue-400 shrink-0">
                            <RefreshCw size={16} className="animate-spin" />
                        </div>
                        <div>
                            <h4 className="text-xs font-bold text-white">¿Cuándo estará de vuelta?</h4>
                            <p className="text-[10px] text-zinc-550 leading-relaxed mt-0.5">
                                Habitualmente las tareas de infraestructura toman entre 15 y 30 minutos. Por favor reintenta ingresar en unos momentos.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="text-[10px] text-zinc-500 font-mono">
                    Archi 24/7 &copy; {new Date().getFullYear()} - Infraestructura Segura.
                </div>
            </div>
        </div>
    );
};

export default Maintenance;
